'use client'

import { createContext, type ReactNode, useContext, useMemo, useState } from 'react'

type HeaderButtonsProviderType = {
  filtersCount: number
  isActive: boolean
  setFiltersCount: (count: number) => void
  setIsActive: (isActive: boolean) => void
}

const HeaderButtonsContext = createContext<HeaderButtonsProviderType | null>(null)

type Props = {
  children: ReactNode
}

export const HeaderButtonsProvider = ({ children }: Props) => {
  const [filtersCount, setFiltersCount] = useState(0)
  const [isActive, setIsActive] = useState(false)

  const value = useMemo(
    () => ({ filtersCount, isActive, setFiltersCount, setIsActive }),
    [filtersCount, isActive, setFiltersCount, setIsActive],
  )

  return <HeaderButtonsContext.Provider value={value}>{children}</HeaderButtonsContext.Provider>
}

export const useHeaderButtons = (): HeaderButtonsProviderType => {
  const header = useContext(HeaderButtonsContext)

  if (!header) throw new Error('useHeaderButtons must be used within HeaderButtonsProvider')

  return header
}
